// extracted by mini-css-extract-plugin
export default {"checkbox":"JoKGT9VF17s7vc7SD2jc","table-data--clickable":"D9Kv_mdoh6CSMaKeMwpI"};